<template>
  <el-table ref="singleTable" :data="allData" :max-height="heightSet" stripe style="width: 100%">
    <el-table-column type="index" width="50" label="序号">
      <template slot-scope="scope">
        <div style="text-align: center">{{scope.$index+1}}</div>
      </template>
    </el-table-column>
    <el-table-column property="name" label="站点名称" align="center">
      <template slot-scope="scope">
<!--        <span style="cursor: pointer; color: #53a0e9;" @click="onToStopDetail(scope.row.poiId)">{{scope.row.name}}</span>-->
        <span>{{scope.row.name}}</span>
      </template>
    </el-table-column>
    <el-table-column property="code" label="站点编码" align="center"></el-table-column>
    <el-table-column property="stationTypeText" label="站点类型" align="center"></el-table-column>
    <el-table-column property="kind" label="站点品牌" align="center"></el-table-column>
    <el-table-column property="longLat" label="经纬度" align="center"></el-table-column>
    <el-table-column property="address" label="地理位置描述" align="center"></el-table-column>
    <el-table-column property="provname" label="省份" align="center"></el-table-column>
    <el-table-column property="cityname" label="城市" align="center"></el-table-column>
    <el-table-column property="adminname" label="区县" align="center"></el-table-column>
    <el-table-column property="flowCount" label="站前流量(次)" align="center"></el-table-column>
    <el-table-column property="stopCount" label="站内停靠(次)" align="center"></el-table-column>
    <el-table-column property="entranceRate" label="进站率(%)" align="center"></el-table-column>
<!--    <el-table-column property="adminname" label="区县" align="center"></el-table-column>-->
<!--    &lt;!&ndash; <el-table-column property="address" label="地理位置" align="center"></el-table-column> &ndash;&gt;-->
<!--    <el-table-column property="count" label="停靠次数" align="center">-->
<!--      <template slot-scope="scope">-->
<!--        {{format(scope.row.count)}}-->
<!--      </template>-->
<!--    </el-table-column>-->
  </el-table>
</template>
<script>
export default {
  props: {
    allData: {
      type: Array,
      default: () => {
        return []
      },
    },
    index: {
      type: Number,
    },
    heightSet: {
      type: Number,
    },
  },
  methods: {
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    onToStopDetail(poiId) {
      this.$emit('on-to-stop-detail', poiId || '')
    },
  },
}
</script>
